export const GENRES = [
  "Trap",
  "Trance",
  "Roots",
  "Rock",
  "Reggae",
  "R&B/Soul",
  "Rap",
  "Punk",
  "Pop",
  "New Age",
  "Metal",
  "Latin",
  "Jazz",
  "Indie",
  "Hip-hop",
  "Gospel",
  "Electronic",
  "Disco",
  "Dance",
  "Country",
  "Contemporary Blues",
  "Classical",
  "Blues",
  "Alternative",
];

export const INSTRUMENTS = [
  "Winds",
  "Vocals",
  "Violin",
  "Percussion",
  "Keys",
  "Horns",
  "Electric Guitar",
  "Drums",
  "DJ",
  "Cello",
  "Beats",
  "Bass",
  "Acoustic Guitar",
  "Accordion",
];
